import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const orgService = {
  getList,
  getDetail,
  getOrgUsers,
  createOrg,
  editOrg,
  getOrgTypes,
  getIngestionStats,
  getScrapeInfo,
  getOcrInfo,
  getDocTypes,
  createDocType,
  editDocType,
  deleteDocType
};

async function getList() {
  const url = SERVER_URL + "/org";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getDetail(org_id) {
  const url = SERVER_URL + "/org/"+org_id;

  const org = await customFetch("GET", url, null, null);
  return org;
}

async function getOrgUsers(org_id) {
  const url = SERVER_URL + "/org/"+org_id+"/users";

  const users = await customFetch("GET", url, null, null);
  return users;
}

async function getDocTypes(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/doctypes";

  const doctypes = await customFetch("GET", url, null, null);
  return doctypes;
}

async function createDocType(docTypeRequest) {
  let url = SERVER_URL + "/org/" + docTypeRequest.org_id + "/doctype"; 

  const result = await customFetch("POST", url, null, JSON.stringify(docTypeRequest));
  return result;
}

async function editDocType(docTypeRequest) {
  let url = SERVER_URL + "/org/"+ docTypeRequest.org_id + "/doctype/" + docTypeRequest.old_name; 

  const result = await customFetch("PUT", url, null, JSON.stringify(docTypeRequest));
  return result;
}

async function deleteDocType(docTypeRequest) {
  let url = SERVER_URL + "/org/" + docTypeRequest.org_id + "/doctype/" + docTypeRequest.doc_type; 

  const result = await customFetch("DELETE", url, null, null);
  return result;
}

async function createOrg(org) {
  let url = SERVER_URL + "/org"; 

  const result = await customFetch("POST", url, null, JSON.stringify(org));
  return result;
}

async function editOrg(org) {
  let url = SERVER_URL + "/org/"+ org.org_id; 

  const result = await customFetch("PUT", url, null, JSON.stringify(org));
  return result;
}

async function getOrgTypes() {
  const url = SERVER_URL + "/org/org_type";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getIngestionStats(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/ingestion";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getScrapeInfo(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/scrape_info";

  const info = await customFetch("GET", url, null, null);
  return info;
}

async function getOcrInfo(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/ocr_info";

  const info = await customFetch("GET", url, null, null);
  return info;
}
